// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otpVerificationContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.verificationText {
  font-family: "Poppins", sans-serif;
  font-weight: 600px;
  font-size: 24px;
  line-height: 32px;
}
.enterText {
  font-family: "Poppins", sans-serif;
  font-weight: 400px;
  font-size: 16px;
  line-height: 24px;
  margin-top: 12px;
}
.enterText2{
  font-family: "Poppins", sans-serif;
  font-weight: 400px;
  font-size: 16px;
  line-height: 24px;
  margin-top: 2px;
}
.enterMobileOtpContainer {
  display: flex;
  align-items: start;
  flex-direction: column;
  margin-top: 5vh;
}
.enterOtpText {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}
.otpInputContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}
.otpInput {
  all: unset;
  border: 1px solid #6a6a6a;
  height: 8vh;
  width: 4vw;
  border-radius: 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 18px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
}
.otpInputError{
  
}
.forgetMobilePasswordTimer {
  font-size: 16px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  color: #48d1cc;
  line-height: 24px;
  margin-top: 4vh;
}
.resendMobileCodeContainer {
  margin-top: 2.5vh;
  font-size: 16px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
}
.resendBtn-disabled {
  all: unset;
}
.resendBtn-active {
  all: unset;
  color: #48d1cc;
  cursor: pointer;
}

@media (max-width: 1640px) {
  .otpInput {
    font-size: 17px;
  }
  .forgetMobilePasswordTimer {
    font-size: 15px;
  }
  .resendMobileCodeContainer {
    font-size: 15px;
  }
}

@media (max-width: 1440px) {
  .otpInput {
    font-size: 16px;
    border-radius: 8px;
  }
  .forgetMobilePasswordTimer {
    font-size: 14px;
  }
  .resendMobileCodeContainer {
    font-size: 14px;
  }
}

@media (max-width: 1280px) {
  .otpInput {
    font-size: 15px;
    border-radius: 8px;
  }
  .forgetMobilePasswordTimer {
    font-size: 13px;
  }
  .resendMobileCodeContainer {
    font-size: 13px;
  }
}

@media (max-width: 1024px) {
  .otpInput {
    font-size: 14px;
    border-radius: 6px;
  }
  .forgetMobilePasswordTimer {
    font-size: 12px;
  }
  .resendMobileCodeContainer {
    font-size: 12px;
  }
}

/* Snackbar Styles */
.snackbar {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 24px;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: white;
  z-index: 1000;
  animation: slideUp 0.3s ease-out;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 250px;
  text-align: center;
}

.snackbar-success {
  background-color: #4caf50;
}

.snackbar-error {
  background-color: #f44336;
}

.snackbar-info {
  background-color: #48d1cc;
}

.snackbar-message {
  display: block;
  line-height: 1.4;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* Responsive adjustments for snackbar */
@media (max-width: 1024px) {
  .snackbar {
    font-size: 13px;
    padding: 10px 20px;
    min-width: 220px;
  }
}

@media (max-width: 768px) {
  .snackbar {
    font-size: 12px;
    padding: 8px 16px;
    min-width: 200px;
    bottom: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/SignUpFlow/MobileOtpVerification/MobileOtpVerification.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;AACA;;AAEA;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n.otpVerificationContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.verificationText {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600px;\n  font-size: 24px;\n  line-height: 32px;\n}\n.enterText {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400px;\n  font-size: 16px;\n  line-height: 24px;\n  margin-top: 12px;\n}\n.enterText2{\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400px;\n  font-size: 16px;\n  line-height: 24px;\n  margin-top: 2px;\n}\n.enterMobileOtpContainer {\n  display: flex;\n  align-items: start;\n  flex-direction: column;\n  margin-top: 5vh;\n}\n.enterOtpText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n}\n.otpInputContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n.otpInput {\n  all: unset;\n  border: 1px solid #6a6a6a;\n  height: 8vh;\n  width: 4vw;\n  border-radius: 10px;\n  box-sizing: border-box;\n  text-align: center;\n  font-size: 18px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n}\n.otpInputError{\n  \n}\n.forgetMobilePasswordTimer {\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  color: #48d1cc;\n  line-height: 24px;\n  margin-top: 4vh;\n}\n.resendMobileCodeContainer {\n  margin-top: 2.5vh;\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n}\n.resendBtn-disabled {\n  all: unset;\n}\n.resendBtn-active {\n  all: unset;\n  color: #48d1cc;\n  cursor: pointer;\n}\n\n@media (max-width: 1640px) {\n  .otpInput {\n    font-size: 17px;\n  }\n  .forgetMobilePasswordTimer {\n    font-size: 15px;\n  }\n  .resendMobileCodeContainer {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 1440px) {\n  .otpInput {\n    font-size: 16px;\n    border-radius: 8px;\n  }\n  .forgetMobilePasswordTimer {\n    font-size: 14px;\n  }\n  .resendMobileCodeContainer {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 1280px) {\n  .otpInput {\n    font-size: 15px;\n    border-radius: 8px;\n  }\n  .forgetMobilePasswordTimer {\n    font-size: 13px;\n  }\n  .resendMobileCodeContainer {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .otpInput {\n    font-size: 14px;\n    border-radius: 6px;\n  }\n  .forgetMobilePasswordTimer {\n    font-size: 12px;\n  }\n  .resendMobileCodeContainer {\n    font-size: 12px;\n  }\n}\n\n/* Snackbar Styles */\n.snackbar {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: white;\n  z-index: 1000;\n  animation: slideUp 0.3s ease-out;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 250px;\n  text-align: center;\n}\n\n.snackbar-success {\n  background-color: #4caf50;\n}\n\n.snackbar-error {\n  background-color: #f44336;\n}\n\n.snackbar-info {\n  background-color: #48d1cc;\n}\n\n.snackbar-message {\n  display: block;\n  line-height: 1.4;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* Responsive adjustments for snackbar */\n@media (max-width: 1024px) {\n  .snackbar {\n    font-size: 13px;\n    padding: 10px 20px;\n    min-width: 220px;\n  }\n}\n\n@media (max-width: 768px) {\n  .snackbar {\n    font-size: 12px;\n    padding: 8px 16px;\n    min-width: 200px;\n    bottom: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
